export function isProduction() {
  return import.meta.env.VITE_DEPLOYMENT_ENV === 'production';
}

export function isNotProduction() {
  return !isProduction();
}

export function isSandboxEnvironment() {
  return import.meta.env.VITE_APP_ENV === 'sandbox';
}